import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class NetworkingExponentGold {
  public static async page(page: number, filters?: any) {
    try {
      useDispatch(Action.Networking.Exponent.Gold.setStatus("loading"));
      const response = await new Model.Networking.Exponent.Gold().page(page, filters);
      useDispatch(Action.Networking.Exponent.Gold.setData(response.data));
      useDispatch(Action.Networking.Exponent.Gold.setStatus("loaded"));
      return response.data;
    } catch (Exception) {
      throw Exception;
    }
  }
}
